module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/icon3.33211a58.png";